// After the Cognito code exchange, the one-time `code` and `state` must leave
// the URL: reloading or bookmarking /members?code=... re-runs the callback
// with a consumed code, which fails and leaves a signed-in user looking
// signed out (the /members guard then sends them to /signup).
const AUTH_PARAMS = ['code', 'state', 'session_state', 'iss', 'error', 'error_description', 'error_uri'];

/**
 * @param {{ pathname: string, search: string, hash: string }} location
 * @returns {string} the same path, query (minus OIDC params) and hash
 */
export const urlWithoutAuthParams = ({ pathname, search, hash }) => {
  const params = new URLSearchParams(search);
  AUTH_PARAMS.forEach((name) => params.delete(name));
  const query = params.toString();
  return `${pathname}${query ? `?${query}` : ''}${hash || ''}`;
};

export const clearAuthParamsFromUrl = () => {
  window.history.replaceState(window.history.state, '', urlWithoutAuthParams(window.location));
};
